import { useState, useCallback } from 'react'

/**
 * Hook that takes care of basic Modal functionality. Exposes isOpen, toggleModal and closeModal. By passing defaultOpen argument to the hook, you can make the modal to be opened by default.
 */
export const useModal = (
  defaultOpen = false,
): [boolean, () => void, () => void] => {
  const [isOpen, setIsOpen] = useState<boolean>(defaultOpen || false)

  const toggleModal = useCallback(() => {
    setIsOpen(isOpen => !isOpen)
  }, [])

  const closeModal = useCallback(() => {
    setIsOpen(false)
  }, [])

  return [isOpen, toggleModal, closeModal]
}
